import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { finalize } from 'rxjs/operators';
import { MatchService } from '../../../_core/services/match.service';
import { ToastService } from '../../../_core/services/toast.service';
import { BoardHelpService } from '../../../match-tracker/tracker-board/board-help.service';
import { Match, ScheduledItem } from '../../models/match.model';
import { Preferences } from '@capacitor/preferences';

@Component({
  standalone: false,
    selector: 'app-suspended-match',
    templateUrl: './suspended-match.component.html',
    styleUrls: ['./suspended-match.component.scss'],
})
export class SuspendedMatchComponent implements OnInit, OnChanges {
    @Input() match: Match;
    @Input() suspensionItem: ScheduledItem;
    @Output() updateSuspendedMatch = new EventEmitter<boolean>();
    @Input() allowContinueTracking = false;
    isSuspended = false;

    isSuspending: boolean;

    constructor(
        private matchService: MatchService,
        private socket: Socket,
        private toast: ToastService,
        private boardHelpService: BoardHelpService) { }

    ngOnInit() {
        this.turnOnSuspendMode();

        this.matchService
            .subscribeEdit()
            .subscribe(
                (match: Match) => {
                    if (this.match._id === match._id) {
                        this.match = match;
                        this.turnOnSuspendMode();
                    }
                }
            );
    }

    ngOnChanges(change: SimpleChanges) {
        if (change.match) {
            this.turnOnSuspendMode();
        }
    }

    getTimeSinceLastPoint() {
        // TODO to test if this is working
        const lastPointTime = this.boardHelpService.getNextToLastPoint(this.match) ? this.boardHelpService.getNextToLastPoint(this.match).timestamp : this.suspensionItem.timeStamp;
        const duration = new Date().getTime() - new Date(lastPointTime).getTime();
        return (this.msToTime(duration));
    }

    private msToTime(duration) {
        let minutes: any = Math.floor((duration / (1000 * 60)) % 60);
        let hours: any = Math.floor((duration / (1000 * 60 * 60)) % 24);

        hours = (hours < 10) ? '0' + hours : hours;
        minutes = (minutes < 10) ? '0' + minutes : minutes;

        return hours + ':' + minutes;
    }

    async stopSuspension() {
        if (this.allowContinueTracking) {
            this.isSuspending = true;
            const scheduledItemObj: ScheduledItem = {
                timeStamp: this.boardHelpService.getLastPoint(this.match).timestamp,
                itemType: 'endTime',
                itemSubject: 'SUSPENSION'
            };

            this.matchService
                .addScheduledItem(scheduledItemObj, this.match._id)
                .pipe(finalize(() => this.isSuspending = false))
                .subscribe(
                    async (res: any) => {
                        let deviceId = (await Preferences.get({ key: 'deviceId' }))?.value;
                        this.match.scheduledItems = res.data;
                        this.turnOnSuspendMode();
                        this.socket.emit('update-match', {matchUp: this.match, deviceId: deviceId});
                    },
                    error => {
                        this.toast.presentDangerToast('Failed to stop suspension');
                    }
                );
        } else {
            this.toast.presentDangerToast('The action is not permitted');
        }
    }

    private turnOnSuspendMode() {
        for (let i = this.match.scheduledItems?.length - 1; i >= 0; i--) {
            const item = this.match.scheduledItems[i];
            if (item.itemSubject === 'SUSPENSION') {
                if (item.itemType === 'startTime') {
                    this.isSuspended = true;
                    this.suspensionItem = item;
                } else if (item.itemType === 'endTime') {
                    this.isSuspended = false;
                    this.suspensionItem = null;
                }
                break;
            }
        }
    }

}
